import { RenderIf } from 'react-rainbow-components';
import UserAvatar from 'components/UserAvatar';
import getDisplayName from 'data/services/profile/getDisplayName';
import getInitials from 'data/services/string/getInitials';
import { Customer, ItemUser } from 'data/firestore/globals';
import ListTile from 'components/ListTile';
import {
    Container, Title, UserLabel, Footer,
} from './styled';
// import ListTile from '../ListTile';

interface CustomerInfoProps {
    customerData: ItemUser[];
    maxVisible: number;
}

const CustomersList = ({
    customerData = [],
    maxVisible,
}: {
    customerData: any[];
    maxVisible: number;
}) => customerData.slice(0, maxVisible).map(
    (user) => {
        const { id } = user as Customer;
        const { uid } = user as ItemUser;
        const displayName = getDisplayName(user);
        const initials = getInitials(displayName);
        const userId = uid || id || '';
        return (
            <ListTile
                icon={(
                    <UserAvatar
                        src={user.photoURL}
                        initials={initials}
                        value={userId}
                        size="small"
                    />
                )}
                title={<UserLabel>{displayName}</UserLabel>}
            />
        );
    },
);

const CustomerInfo = ({ customerData, maxVisible }: CustomerInfoProps) => {
    const customers = (!Array.isArray(customerData) ? [customerData] : customerData);
    return (
        <Container>
            <Title>{`There are ${customers.length} customers with this phone number:`}</Title>
            <CustomersList
                customerData={customers}
                maxVisible={maxVisible}
            />
            <RenderIf isTrue={customers.length > maxVisible}>
                <Footer>{`and ${customers.length - maxVisible} more.`}</Footer>
            </RenderIf>
        </Container>
    );
};

export default CustomerInfo;
